import { AnalysisResult } from "../generated-api-proxy";
import { GroupScoreViewModel } from "./group-score-view-model";

export class AnalysisViewModel {
  created_at: Date | null = null;
  updated_at: Date | null = null;
  missing: boolean = false;
  total: GroupScoreViewModel = GroupScoreViewModel.empty();
  parts: GroupScoreViewModel[] = [];
  constructor(analysis: AnalysisResult | null) {
    if (!analysis)
      return;

    this.created_at = new Date(analysis.created_at);
    this.updated_at = new Date(analysis.updated_at);

    if (analysis["total"]) {
      this.total = new GroupScoreViewModel(analysis["total"], "total");
      this.missing = analysis["total"]["missing"]
    }

    if (this.missing) return;

    for (var i in analysis) {
      if (i == 'created_at') continue;
      if (i == 'updated_at') continue;
      if (i == 'total') continue;
      if (i.startsWith("dim") || i.startsWith("Dim")) continue;

      this.parts.push(new GroupScoreViewModel(analysis[i], i));
    }
  }

  static empty(): AnalysisViewModel {
    return new AnalysisViewModel(null);
  }
}
